import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';
import device from '~/config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 30px;
  overflow: auto;

  h1 {
    color: var(--blueDark);
  }

  button {
    background: var(--yellowDark);
    color: var(--blueDark);
    border-radius: 10px;
    padding: 5px 10px;
    margin-top: 15px;
    font-weight: bold;
    box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
    transition: background 0.2s;
  }

  button:hover {
    background: ${darken(0.06, '#f7c325')};
  }

  #ifmcontentstoprint {
    * {
      background: red;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  color: var(--blueDark);
  margin: 10px;

  h3 {
    padding: 1px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.9rem;
  }

  h3.title {
    justify-content: space-between;
    align-items: center;
    margin: -1%;
    padding-right: 1%;
  }

  p {
    font-size: 1.7rem;

    @media (max-width: 426px) {
      font-size: larger;
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const SelectContainer = styled.div`
  width: 500px;
  padding-top: 50px;
  margin: 0 auto;
  text-align: center;

  @media ${device.mobileMinMobMax} {
    width: 80%;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  color: var(--greenDark);
  font-size: 1.1rem;
  flex-direction: column;

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 30px;

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      section {
        margin: 0 20px;
      }
    }
  }

  h3 {
    border-bottom: 2px solid var(--yellowDark);
    padding: 15px 15px;
  }

  section {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .bold {
    font-weight: bold;
  }

  Table {
    width: 100%;
  }

  .line {
    margin-top: 20px;
    border-top: 2px solid var(--yellowDark);
  }

`;
